export const pricing = {
  regular: 'AR$ 84.950',
  today: 'AR$ 16.990',
  totalValue: 'AR$ 509.700',
  bonusValue: 'AR$ 424.750',
  savings: 'AR$ 492.710',
  bonusUnitValue: 'AR$ 84.950',
}

export const productImage =
  'https://cdn.magicpatterns.com/uploads/2wAmTLUGKaKAGrpHqvoaV9/ChatGPT_Image_4_sept_2026,_06_42_29_p.m..png'

export type Bonus = {
  id: string
  number: string
  emoji: string
  image: string
  imageAlt: string
  title: string
  teaser: string
  headline: string
  paragraphs: string[]
  listTitle: string
  items: string[]
}

export type PackItem = {
  id: string
  kind: 'principal' | 'bono'
  label: string
  emoji: string
  image: string
  imageAlt: string
  title: string
  teaser: string
  headline: string
  paragraphs: string[]
  listTitle: string
  items: string[]
  price: string
  priceNote: string
}

export const mainProgram = {
  id: 'megapack',
  emoji: '🌱',
  image: productImage,
  imageAlt: 'Caja del MegaPack Hábitos junto al diario, la guía práctica y las versiones digitales.',
  title: 'MegaPack Hábitos',
  teaser:
    'El programa principal de 21 días para empezar a transformar tu rutina paso a paso.',
  headline: 'El sistema práctico de 21 días para empezar a cambiar tus hábitos',
  paragraphs: [
    'Vas a encontrar acciones simples y progresivas para incorporar nuevos hábitos, organizar mejor tus días y construir constancia sin depender de la motivación.',
  ],
  listTitle: 'Incluye:',
}

export const bonuses: Bonus[] = [
  {
    id: 'bono-1',
    number: '01',
    emoji: '🚫',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/14213455-c0e8-44d4-9143-6487ce22f6e0.jpg',
    imageAlt: 'Libreta con una lista de hábitos tachados, un celular boca abajo y una rama verde.',
    title: 'Elimina los Malos Hábitos',
    teaser:
      'Descubrí por qué repetís hábitos que sabés que no te hacen bien y cómo empezar a reemplazarlos progresivamente.',
    headline: 'Una guía práctica para romper los patrones que te están frenando',
    paragraphs: [
      'No alcanza con incorporar buenos hábitos si seguís repitiendo automáticamente los que te quitan tiempo, energía y concentración.',
      'Con esta guía vas a aprender a identificar qué está detrás de tus malos hábitos, detectar qué los desencadena y empezar a reemplazarlos progresivamente por comportamientos más positivos.',
    ],
    listTitle: 'Incluye ejercicios prácticos para:',
    items: [
      'Identificar tus principales hábitos negativos.',
      'Detectar qué los desencadena.',
      'Reconocer los momentos en los que sos más vulnerable.',
      'Crear alternativas más saludables.',
      'Diseñar un plan para reducirlos progresivamente.',
    ],
  },
  {
    id: 'bono-2',
    number: '02',
    emoji: '⚡',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5068a0f7-2018-4ab4-a5f5-f5cec23ebee0.jpg',
    imageAlt: 'Reloj de arena junto a una lapicera verde y fichas en blanco sobre fondo crema.',
    title: 'Kit Anti-Procrastinación',
    teaser:
      'Herramientas prácticas para dejar de postergar, empezar tareas y recuperar el enfoque incluso cuando no tengas ganas.',
    headline: 'Las herramientas para dejar de postergar y empezar a actuar',
    paragraphs: [
      '¿Cuántas cosas importantes seguís dejando para después?',
      'Este kit reúne estrategias simples para superar esa resistencia inicial, empezar las tareas pendientes y recuperar el control de tu tiempo.',
      'Vas a tener herramientas concretas para esos momentos en los que sabés exactamente qué tenés que hacer, pero no conseguís empezar.',
    ],
    listTitle: 'Incluye:',
    items: [
      'Técnica de los 5 minutos.',
      'Lista de tareas pendientes.',
      'Método para dividir tareas grandes.',
      'Ejercicio para identificar tus principales distracciones.',
      'Checklist para recuperar el enfoque.',
      'Plan de acción para los días de baja motivación.',
    ],
  },
  {
    id: 'bono-3',
    number: '03',
    emoji: '📊',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/37c2021c-8fea-451c-9937-f66964c531e1.jpg',
    imageAlt: 'Planilla de seguimiento de hábitos con casilleros marcados y un lápiz apoyado.',
    title: 'Tracker de Hábitos 90 Días',
    teaser:
      'Convertí tu progreso en algo visible: registrá tus hábitos, observá tu evolución y detectá cuándo perdés constancia.',
    headline: 'Convertí tu constancia en algo visible',
    paragraphs: [
      'Lo que podés ver, registrar y medir es mucho más fácil de sostener.',
      'Con este tracker vas a poder registrar tus hábitos, visualizar tus avances y detectar rápidamente cuándo estás perdiendo constancia.',
      'Y lo mejor: podés seguir utilizándolo después de completar los 21 días para continuar construyendo tu nueva rutina.',
    ],
    listTitle: 'Incluye:',
    items: [
      'Calendario de 90 días.',
      'Registro diario de hábitos.',
      'Espacio para objetivos.',
      'Seguimiento semanal.',
      'Evaluaciones mensuales.',
      'Sección de logros y avances.',
    ],
  },
  {
    id: 'bono-4',
    number: '04',
    emoji: '🔄',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6f8620d-113f-4148-9198-a6435f891cc0.jpg',
    imageAlt: 'Manta doblada, vaso de agua, planta y celular boca abajo en un ambiente ordenado.',
    title: 'Plan de Reset',
    teaser:
      '¿Sentís que perdiste el ritmo? Un plan de 7 días para volver a empezar sin intentar cambiar todo de golpe.',
    headline: '7 días para volver a poner tu rutina en orden',
    paragraphs: [
      'Hay momentos en los que todo se desorganiza. Dormís mal, dejás de cumplir tus hábitos, pasás demasiado tiempo con el celular, acumulás tareas y sentís que necesitás empezar de nuevo.',
      'Para esos momentos creamos el Plan de Reset.',
      'Durante 7 días vas a realizar pequeñas acciones para recuperar progresivamente el orden, despejar tu mente y volver a tomar el control de tu rutina.',
    ],
    listTitle: 'Incluye:',
    items: [
      '7 acciones de reset.',
      'Orden y limpieza de tu entorno.',
      'Organización de pendientes.',
      'Desconexión digital.',
      'Recuperación de hábitos básicos.',
      'Planificación de la semana.',
      'Ejercicio final para volver a empezar.',
    ],
  },
  {
    id: 'bono-5',
    number: '05',
    emoji: '🧩',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/eddd01d1-f457-48c3-98ce-57ed1c0dd85a.jpg',
    imageAlt: 'Planificador semanal abierto con fichas y una lapicera verde sobre fondo crema.',
    title: 'Mi Sistema de Hábitos',
    teaser:
      'El paso final para dejar de depender de un desafío y tener tu propio sistema de hábitos sostenible.',
    headline: 'Creá tu propio sistema para mantener tus cambios a largo plazo',
    paragraphs: [
      'El desafío de 21 días te ayuda a empezar. Pero para mantener lo que construiste necesitás un sistema que puedas adaptar a tu propia vida.',
      'Con este recurso vas a organizar tus hábitos, definir cuándo realizarlos, hacer seguimiento de tu progreso y establecer qué hacer cuando aparezcan obstáculos.',
    ],
    listTitle: 'Incluye:',
    items: [
      'Mapa de hábitos personales.',
      'Rutina diaria editable.',
      'Planificador semanal.',
      'Lista de hábitos no negociables.',
      'Sistema de seguimiento.',
      'Plan para días difíciles.',
      'Revisión mensual de progreso.',
    ],
  },
]

export const bonusShortList = [
  'Elimina los Malos Hábitos',
  'Kit Anti-Procrastinación',
  'Tracker de Hábitos 90 Días',
  'Plan de Reset',
  'Mi Sistema de Hábitos',
]

export type Benefit = {
  icon: 'plan' | 'calendar' | 'brain' | 'leaf'
  title: string
  paragraphs: string[]
}

export const benefits: Benefit[] = [
  {
    icon: 'plan',
    title: 'Un plan diario que sabés exactamente cómo seguir',
    paragraphs: [
      'No necesitás sentarte a decidir qué hacer cada día.',
      'El MegaPack te guía con acciones concretas y progresivas para que puedas avanzar paso a paso sin intentar cambiar toda tu vida de un día para el otro.',
    ],
  },
  {
    icon: 'calendar',
    title: 'Más organización y control sobre tu día',
    paragraphs: [
      'Los pequeños hábitos pueden cambiar la forma en la que organizás tu tiempo.',
      'Vas a trabajar con acciones simples que te ayudan a ordenar tu rutina, reducir el caos y dejar de sentir que el día te lleva puesto.',
    ],
  },
  {
    icon: 'brain',
    title: 'Constancia sin depender de estar motivado',
    paragraphs: [
      'La motivación sube y baja.',
      'Por eso el objetivo no es esperar a tener ganas, sino crear una estructura que te permita seguir avanzando incluso en los días en los que tu motivación no está al 100%.',
    ],
  },
  {
    icon: 'leaf',
    title: 'Cambios progresivos que puedas llevar a tu vida real',
    paragraphs: [
      'No necesitás convertirte en otra persona de la noche a la mañana.',
      'Vas a trabajar con hábitos pequeños y realistas que puedas adaptar a tus horarios, responsabilidades y vida cotidiana.',
    ],
  },
]

export type Pain = {
  title: string
  paragraphs: string[]
  answer: string
}

export const pains: Pain[] = [
  {
    title: 'Empezás con toda la motivación… y abandonás a los pocos días',
    paragraphs: [
      'El lunes arrancás con todo: nueva rutina, nuevos objetivos, nuevas reglas. Pero unos días después volvés a lo mismo.',
      'El problema no siempre es la falta de voluntad. Muchas veces es intentar cambiar demasiado, demasiado rápido.',
    ],
    answer:
      'El desafío de 21 días te propone avanzar de manera progresiva para que puedas construir constancia sin sentir que tenés que hacerlo todo perfecto.',
  },
  {
    title: 'Sabés lo que tenés que hacer, pero seguís postergándolo',
    paragraphs: [
      'Tenés tareas pendientes. Sabés por dónde empezar.',
      'Pero terminás mirando el celular, ordenando otra cosa o diciéndote “después lo hago”.',
    ],
    answer:
      'El Kit Anti-Procrastinación te da herramientas concretas para romper ese ciclo y pasar de pensar a actuar.',
  },
  {
    title: 'Tu motivación aparece y desaparece',
    paragraphs: [
      'Un día estás decidido a cambiar. Al siguiente no tenés ganas de hacer nada.',
      'Y cuando dependés exclusivamente de la motivación, cualquier día malo puede hacerte abandonar.',
    ],
    answer:
      'Por eso el sistema está pensado para ayudarte a desarrollar constancia y apoyarte en una estructura diaria.',
  },
  {
    title: 'Sentís que no tenés tiempo para hacer todo lo que querés',
    paragraphs: [
      'No necesitás llenar tu agenda de nuevas obligaciones.',
      'Necesitás aprender a incorporar pequeñas acciones que tengan sentido dentro de tu rutina actual.',
    ],
    answer: 'El MegaPack te ayuda a organizar tus hábitos de forma simple y progresiva.',
  },
  {
    title: 'Cada vez que perdés el ritmo sentís que tenés que empezar desde cero',
    paragraphs: ['Un día no cumplís. Después vienen dos. Y finalmente abandonás todo.'],
    answer:
      'Con el Tracker de 90 días y el Plan de Reset, tenés herramientas para recuperar el ritmo y continuar en lugar de tirar todo por la borda.',
  },
]

export type Step = {
  number: string
  title: string
  paragraphs: string[]
}

export const steps: Step[] = [
  {
    number: '1',
    title: 'Iniciás tu cuenta regresiva de 21 días',
    paragraphs: [
      'Elegís el hábito o los hábitos que querés trabajar y te preparás para comenzar un proceso guiado, con acciones claras y progresivas.',
    ],
  },
  {
    number: '2',
    title: 'Completás una acción por día',
    paragraphs: [
      'Cada día tenés un paso concreto para realizar. No necesitás hacerlo perfecto.',
      'Lo importante es avanzar y construir la repetición que convierte una acción puntual en parte de tu rutina.',
    ],
  },
  {
    number: '3',
    title: 'Consolidás el cambio y continuás',
    paragraphs: [
      'Al terminar los 21 días, no se termina todo.',
      'Con el Tracker de Hábitos de 90 Días y Mi Sistema de Hábitos, tenés herramientas para continuar registrando tu progreso y mantener lo que construiste.',
    ],
  },
]

export type Faq = {
  question: string
  answer: string[]
}

export const faqs: Faq[] = [
  {
    question: '¿Y si no tengo fuerza de voluntad?',
    answer: [
      'No necesitás una fuerza de voluntad extraordinaria.',
      'El objetivo del MegaPack es justamente ayudarte a dejar de depender exclusivamente de la motivación y empezar a apoyarte en acciones pequeñas, repetibles y fáciles de incorporar.',
    ],
  },
  {
    question: '¿Qué pasa si un día no cumplo?',
    answer: [
      'No significa que hayas fracasado.',
      'Un día malo no tiene por qué convertirse en una semana perdida. El sistema está pensado para que puedas retomar, ajustar y continuar.',
    ],
  },
  {
    question: '¿Sirve si soy muy desordenado/a o ya probé otros métodos?',
    answer: [
      'Sí. No necesitás tener una rutina perfecta antes de empezar.',
      'El programa parte justamente de una situación real: querer cambiar, pero tener dificultades para mantener la constancia.',
    ],
  },
  {
    question: '¿Cuánto tiempo lleva por día?',
    answer: [
      'El desafío está pensado para trabajar con acciones simples y concretas, evitando que tengas que dedicar horas de tu día a construir nuevos hábitos.',
      'La idea es que puedas integrarlo a tu rutina real.',
    ],
  },
  {
    question: '¿Voy a poder aplicarlo a mi vida cotidiana?',
    answer: [
      'Sí. El objetivo no es darte una rutina imposible de mantener.',
      'Es ayudarte a construir hábitos que puedas adaptar a tu vida, tus horarios y tus responsabilidades.',
    ],
  },
]

export const packIncludes = [
  'Desafío de hábitos de 21 días',
  'Plan diario progresivo',
  'Herramientas de organización',
  'Sistema para construir constancia',
]

export const packItems: PackItem[] = [
  {
    id: mainProgram.id,
    kind: 'principal',
    label: 'Programa principal',
    emoji: mainProgram.emoji,
    image: mainProgram.image,
    imageAlt: mainProgram.imageAlt,
    title: mainProgram.title,
    teaser: mainProgram.teaser,
    headline: mainProgram.headline,
    paragraphs: mainProgram.paragraphs,
    listTitle: mainProgram.listTitle,
    items: packIncludes,
    price: pricing.today,
    priceNote: 'Pago único',
  },
  ...bonuses.map<PackItem>((bonus) => ({
    id: bonus.id,
    kind: 'bono',
    label: `Bono #${Number(bonus.number)}`,
    emoji: bonus.emoji,
    image: bonus.image,
    imageAlt: bonus.imageAlt,
    title: bonus.title,
    teaser: bonus.teaser,
    headline: bonus.headline,
    paragraphs: bonus.paragraphs,
    listTitle: bonus.listTitle,
    items: bonus.items,
    price: pricing.bonusUnitValue,
    priceNote: 'Gratis',
  })),
]
